module.exports = __webpack_public_path__ + "img/vue2-milieu_bleu.e507ff3e.png";